import { z } from 'zod'
import type { StoreSyncPartStatus, StoreSyncStatus } from '../../models/StoreSyncStatus'

const StoreSyncPartStatusDTOSchema = z.object({
  needs_sync: z.boolean(),
  is_syncing: z.boolean(),
  last_synced_at: z.string().nullable().optional(),
  sync_requested_at: z.string().nullable().optional(),
  error_message: z.string().nullable().optional()
})

export const StoreSyncStatusDTOSchema = z.object({
  syncing: z.boolean(),
  needs_sync: z.boolean(),
  active_batch: z.array(z.enum(['merchant', 'menu', 'legal_terms'])).nullable().optional(),
  parts: z.object({
    merchant: StoreSyncPartStatusDTOSchema,
    menu: StoreSyncPartStatusDTOSchema,
    legal_terms: StoreSyncPartStatusDTOSchema
  })
})

export const StoreSyncStatusSnippetSchema = StoreSyncStatusDTOSchema

export const StoreSyncStatusResponseSchema = z.object({
  data: StoreSyncStatusDTOSchema
})

function mapPart (dto: z.infer<typeof StoreSyncPartStatusDTOSchema>): StoreSyncPartStatus {
  return {
    needsSync: dto.needs_sync,
    isSyncing: dto.is_syncing,
    lastSyncedAt: dto.last_synced_at ?? null,
    syncRequestedAt: dto.sync_requested_at ?? null,
    errorMessage: dto.error_message ?? null
  }
}

export function mapDTOToStoreSyncStatus (dto: z.infer<typeof StoreSyncStatusDTOSchema>): StoreSyncStatus {
  return {
    syncing: dto.syncing,
    needsSync: dto.needs_sync,
    activeBatch: dto.active_batch ?? null,
    parts: {
      merchant: mapPart(dto.parts.merchant),
      menu: mapPart(dto.parts.menu),
      legal_terms: mapPart(dto.parts.legal_terms)
    }
  }
}
